/**
 * An invite link opened while signed out. Sign-in by email link finishes in a
 * new tab, which has none of this tab's sessionStorage and lands on `/`, so
 * the token is kept in localStorage for a short while and the console sends
 * the next `/` landing back to `/join/<token>`.
 */

const PENDING_JOIN_KEY = 'nimbalyst.pendingJoin';
const PENDING_JOIN_TTL_MS = 60 * 60 * 1000;

export const JOIN_PATH_PREFIX = '/join/';

export function joinPath(token: string): string {
  return `${JOIN_PATH_PREFIX}${encodeURIComponent(token)}`;
}

export function joinTokenFromPath(pathname: string): string | null {
  if (!pathname.startsWith(JOIN_PATH_PREFIX)) return null;
  const token = decodeURIComponent(pathname.slice(JOIN_PATH_PREFIX.length)).trim();
  return token && !token.includes('/') ? token : null;
}

export function rememberPendingJoin(token: string, now = Date.now()): void {
  try {
    localStorage.setItem(PENDING_JOIN_KEY, JSON.stringify({ token, at: now }));
  } catch {
    // Storage off: the same-tab return path still works.
  }
}

export function peekPendingJoin(now = Date.now()): string | null {
  try {
    const raw = localStorage.getItem(PENDING_JOIN_KEY);
    if (!raw) return null;
    const { token, at } = JSON.parse(raw) as { token?: unknown; at?: unknown };
    if (typeof token !== 'string' || typeof at !== 'number' || now - at > PENDING_JOIN_TTL_MS) {
      localStorage.removeItem(PENDING_JOIN_KEY);
      return null;
    }
    return token;
  } catch {
    return null;
  }
}

export function clearPendingJoin(): void {
  try {
    localStorage.removeItem(PENDING_JOIN_KEY);
  } catch {
    // Nothing to clear.
  }
}
